module.exports = __webpack_public_path__ + "img/佳湘麵包.69f45cea.svg";